export const isAllowedToCreateEncounter = ({
  remainingEncounters,
  canCreateEncounter,
}) => {
  if (
    (remainingEncounters !== null && remainingEncounters <= 0) ||
    !canCreateEncounter
  ) {
    return false;
  }
  return true;
};

export const isAllowedToGenerateSummary = ({
  encounterPhase,
  canGenerateInVisitSummary,
  canGeneratePreChartSummary,
  canGenerateAfterVisitSummary,
}) => {
  if (
    (encounterPhase === 'in-visit' && canGenerateInVisitSummary) ||
    (encounterPhase === 'pre-chart' && canGeneratePreChartSummary) ||
    (encounterPhase === 'after-visit' && canGenerateAfterVisitSummary)
  ) {
    return true;
  }
  return false;
};

export const isAllowedToStartEncounter = ({
  encounterPhase,
  canStartInVisitEncounter,
  canStartPreChartEncounter,
}) => {
  if (
    (encounterPhase === 'in-visit' && canStartInVisitEncounter) ||
    (encounterPhase === 'pre-chart' && canStartPreChartEncounter)
  ) {
    return true;
  }
  return false;
};

export const isAllowedToUpdateSummary = ({
  encounterPhase,
  isInVisitSummaryUpdateAllowed,
  isPreChartSummaryUpdateAllowed,
  isAfterVisitSummaryUpdateAllowed,
  isDictationSummaryUpdateAllowed,
}) => {
  if (encounterPhase === 'in-visit' && isInVisitSummaryUpdateAllowed) {
    return true;
  }
  if (encounterPhase === 'pre-chart' && isPreChartSummaryUpdateAllowed) {
    return true;
  }
  if (encounterPhase === 'after-visit' && isAfterVisitSummaryUpdateAllowed) {
    return true;
  }
  if (encounterPhase === 'dictate' && isDictationSummaryUpdateAllowed) {
    return true;
  }
  return false;
};
